class MainController {
  /* @ngInject */
  constructor(GROUPS, Session) {
    this.GROUPS = GROUPS;
    this.Session = Session;
  }

  $onInit() {
    this.user = this.Session.read('userinfo');
  }
}

export default MainController;



// WEBPACK FOOTER //
// ./client/app/main/main.controller.js